import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/**
 * Anillo de progreso circular (donut SVG) del header del banner de onboarding. Presentacional puro:
 * recibe el porcentaje y el conteo de tareas hechas/totales y los pinta. El trazo coloreado avanza
 * con `value` usando `stroke-dasharray`/`stroke-dashoffset` sobre un anillo gris de fondo.
 */
@Component({
    selector: 'fina-onboarding-progress-ring',
    templateUrl: './onboarding-progress-ring.component.html',
    styleUrls: ['onboarding-progress-ring.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OnboardingProgressRingComponent {
    /** Porcentaje 0-100 (progress.overall de la fase). */
    @Input() percent = 0;
    /** Tareas completadas (para el texto "X/Y Done"). */
    @Input() done = 0;
    /** Tareas totales (para el texto "X/Y Done"). */
    @Input() total = 0;
    /** Modo compacto (Fase 2): anillo más pequeño y sin el sub-label "X/Y Done". */
    @Input() compact = false;

    // Geometría del SVG. El radio define la circunferencia que sirve de base al dash.
    get radius(): number {
        return this.compact ? 18 : 32;
    }
    get stroke(): number {
        return this.compact ? 4 : 6;
    }

    get circumference(): number {
        return 2 * Math.PI * this.radius;
    }

    /** Largo del trazo "vacío": a 100% el offset es 0 (anillo completo); a 0% es la circunferencia. */
    get dashOffset(): number {
        const clamped = Math.max(0, Math.min(100, this.percent || 0));
        return this.circumference * (1 - clamped / 100);
    }

    get center(): number {
        return this.radius + this.stroke;
    }

    get size(): number {
        return (this.radius + this.stroke) * 2;
    }
}
